'use client';
import { AnchorButton } from '@egalite/ui/IncluiPCD/RegisterCompany/AnchorButton';
import { BenefitCard, BenefitsCardsWrapper } from '@egalite/ui/IncluiPCD/RegisterCompany/BenefitsCards';
import { Section } from '@egalite/ui/IncluiPCD/RegisterCompany/BenefitsSection';
import {
    BenefitsCell,
    BenefitsHeaderCell,
    BenefitsRow,
    BenefitsTable,
    FalseIcon,
    TrueIcon,
} from '@egalite/ui/IncluiPCD/RegisterCompany/BenefitsTable';
import Typography from '@egalite/ui/Typography';
import { FC, ReactElement } from 'react';

const tableData: { header: string[]; rows: (string | ReactElement)[][] } = {
    header: ['', 'Plataforma', 'Patrocinador', 'Apoiador', 'Participante'],
    rows: [
        ['Cadastro de vagas', <TrueIcon key="1" />, <TrueIcon key="2" />, <TrueIcon key="3" />, '10 vagas'],
        ['Acesso ilimitado a candidatos inscritos nas vagas', <TrueIcon key="4" />, <TrueIcon key="5" />, <TrueIcon key="6" />, 'após o término da feira'],
        ['Busca ativa de candidatos', <TrueIcon key="7" />, <TrueIcon key="8" />, <TrueIcon key="9" />, <FalseIcon key="10" />],
        ['Divulgação do logo na home', <TrueIcon key="11" />, <TrueIcon key="12" />, <TrueIcon key="13" />, <FalseIcon key="14" />],
        ['Página de vagas personalizada', <TrueIcon key="15" />, <TrueIcon key="16" />, <FalseIcon key="17" />, <FalseIcon key="18" />],
        ['Integração com ATS', <TrueIcon key="19" />, <TrueIcon key="20" />, <FalseIcon key="21" />, <FalseIcon key="22" />],
        ['Painel durante a feira', <TrueIcon key="23" />, <TrueIcon key="24" />, <FalseIcon key="25" />, <FalseIcon key="26" />],
        ['Divulgação de vagas o ano todo', <TrueIcon key="27" />, <FalseIcon key="28" />, <FalseIcon key="29" />, <FalseIcon key="30" />],
        ['Envios de Whatsapp para candidatos', <TrueIcon key="31" />, <FalseIcon key="32" />, <FalseIcon key="33" />, <FalseIcon key="34" />],
    ],
};

const cardsData = [
    {
        header: 'Plataforma',
        items: [
            'Cadastro de vagas',
            'Acesso ilimitado a candidatos inscritos nas vagas',
            'Busca ativa de candidatos',
            'Divulgação do logo na home',
            'Página de vagas personalizada',
            'Integração com ATS',
            'Painel durante a feira',
            'Divulgação de vagas o ano todo',
            'Envios de Whatsapp para candidatos',
        ],
    },
    {
        header: 'Patrocinador',
        items: [
            'Cadastro de vagas',
            'Acesso ilimitado a candidatos inscritos nas vagas',
            'Busca ativa de candidatos',
            'Divulgação do logo na home',
            'Página de vagas personalizada',
            'Integração com ATS',
            'Painel durante a feira',
        ],
    },
    {
        header: 'Apoiador',
        items: [
            'Cadastro de vagas',
            'Acesso ilimitado a candidatos inscritos nas vagas',
            'Busca ativa de candidatos',
            'Divulgação do logo na home',
        ],
    },
    {
        header: 'Participante',
        items: ['Cadastro de até 10 vagas', 'Acesso aos candidatos inscritos nas vagas após o término da feira'],
    },
];

const Benefits: FC = () => {
    return (
        <Section id="beneficios">
            <Typography variant="headline-2" className="text-center">
                Como Patrocinador e Apoiador da IncluiPcD você tem acesso a benefícios exclusivos:
            </Typography>
            <BenefitsCardsWrapper>
                {cardsData.map((card, idx) => (
                    <BenefitCard key={`card-${idx}`} {...card} />
                ))}
            </BenefitsCardsWrapper>
            <BenefitsTable>
                <thead>
                    <BenefitsRow>
                        {tableData.header.map((header, idx) => (
                            <BenefitsHeaderCell key={`header-${idx}`}>
                                {header}
                            </BenefitsHeaderCell>
                        ))}
                    </BenefitsRow>
                </thead>
                <tbody>
                    {tableData.rows.map((row, idx) => (
                        <BenefitsRow key={`row-${idx}`}>
                            {row.map((cell, cellIdx) => (
                                <BenefitsCell key={`cell-${cellIdx}`}>{cell}</BenefitsCell>
                            ))}
                        </BenefitsRow>
                    ))}
                </tbody>
            </BenefitsTable>
            <AnchorButton />
        </Section>
    );
};

export default Benefits;
